import { render, staticRenderFns } from "./UserInfoLogo.vue?vue&type=template&id=6a488307&scoped=true&"
import script from "./UserInfoLogo.vue?vue&type=script&lang=js&"
export * from "./UserInfoLogo.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoLogo.vue?vue&type=style&index=0&id=6a488307&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a488307",
  null
  
)

export default component.exports